export default __webpack_public_path__ + "static/media/Icon-2.cfac69a1.svg";